__webpack_require__.p = "https://boats.magnificodouro.pt/";